import { FETCH_BANK_DETAIL_SUCCESS } from "../actionType";
import {
    PORTFOLIO_SUMMARY_REQUEST,
    PORTFOLIO_SUMMARY_ERROR,
    PORTFOLIO_SUMMARY_SUCCESS,
    WITHDRAW_MONEY,
    WITHDRAW_MONEY_SUCCESS,
    WITHDRAW_MONEY_ERROR,
    ADD_MONEY_ERROR,
    ADD_MONEY_SUCCESS,
    ADD_MONEY,
    REFER_EARN_REQUEST,
    REFER_EARN_ERROR,
    REFER_EARN_SUCCESS,
    INVESTMENT_SUMMARY_REQUEST,
    INVESTMENT_SUMMARY_SUCCESS,
    INVESTMENT_SUMMARY_ERROR,
    CASH_LEDGER_REQUEST,
    CASH_LEDGER_SUCCESS,
    CASH_LEDGER_ERROR,
    FETCH_BORROWER_DETAILS,
    FETCH_BORROWER_DETAILS_ERROR,
    FETCH_BORROWER_DETAILS_SUCCESS,
    SELECT_TENURE_VALUE,
    RESET_WITHDRAWAL_AMOUNT,
    ADD_AMOUNT_VALUE
} from "./actionsTypes";

export const getPortfolioSummaryRequest = () => ({
    type: PORTFOLIO_SUMMARY_REQUEST,
});

export const getPortfolioSummarySuccess = (data: any) => ({
    type: PORTFOLIO_SUMMARY_SUCCESS,
    payload: data
});

export const getPortfolioSummaryError = (error: any) => ({
    type: PORTFOLIO_SUMMARY_ERROR,
    payload: error
});

export const getInvestmentSummaryRequest = () => ({
    type: INVESTMENT_SUMMARY_REQUEST,
})

export const getInvestmentSummarySuccess = (data:any) => ({
    type: INVESTMENT_SUMMARY_SUCCESS,
    payload:data
});

export const getInvestmentSummaryError = (error:any) => ({
    type:INVESTMENT_SUMMARY_ERROR,
    payload:error
});

export const getCashLedgerRequest = () => ({
    type: CASH_LEDGER_REQUEST
})
export const getCashLedgerSuccess = (data:any) => ({
    type:CASH_LEDGER_SUCCESS,
    payload:data
});
export const getCashLedgerError = (error:any) => ({
    type: CASH_LEDGER_ERROR,
    payload: error
})

export const withdrawMoney = () => ({
    type: WITHDRAW_MONEY,
})

export const withdrawMoneySuccess = (data: any) => ({
    type: WITHDRAW_MONEY_SUCCESS,
    payload: data
})

export const withdrawMoneyError = (error: any) => ({
    type: WITHDRAW_MONEY_ERROR,
    error
})

export const AddMoney = () => ({
    type: ADD_MONEY,
})

export const AddMoneySuccess = (data: any) => ({
    type: ADD_MONEY_SUCCESS,
    payload: data
})

export const AddMoneyError = (error: any) => ({
    type: ADD_MONEY_ERROR,
    payload: error
})

export const getReferEarnRequest = () => ({
    type: REFER_EARN_REQUEST,
});

export const getReferEarnSuccess = (data: any) => ({
    type: REFER_EARN_SUCCESS,
    payload: data
});

export const getReferEarnError = (error: any) => ({
    type: REFER_EARN_ERROR,
    payload: error
});

export const fetchBorrowerDetails = () => ({
    type: FETCH_BORROWER_DETAILS
});

export const fetchBorrowerDetailsSuccess = (data:any) =>({
    type: FETCH_BORROWER_DETAILS_SUCCESS,
    payload:data
});

export const fetchBorrowerDetailsError =(error:any) => ({
    type:FETCH_BORROWER_DETAILS_ERROR,
    payload: error
})

export const setTenureValue = (data:any) =>({
    type: SELECT_TENURE_VALUE,
    payload:data
});

export const resetWithdrawal = () =>({
    type: RESET_WITHDRAWAL_AMOUNT,
});

export const setAmountValue = (data:any) =>({
    type: ADD_AMOUNT_VALUE,
    payload:data
});
